// extracted by mini-css-extract-plugin
export default {"use_court_verification":"styles_use_court_verification__mjC1Y","notEmpty":"styles_notEmpty__A1Wrx"};